import styled from 'styled-components'
import { grid, layout, padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PADDING_X } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.attrs({
  py: [20, 20, 20, 56],
  px: PADDING_X,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: ${themeGet('colors.bg.primary')};

  ${padding}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${BLUEPRINT_WIDTH}px;

  @media screen and (max-width: ${themeGet('breakpoints.0')}) {
    > div:first-child {
      align-self: flex-start;
      align-items: flex-start;

      > div:first-child {
        width: auto;
        align-self: flex-start;
      }
    }
  }
`

export const CardsContainer = styled.div
  .attrs({
    gridColumnGap: [9, 9, 9, 6],
    gridRowGap: [9, 9, 9, 7],
    gridTemplateColumns: ['1fr', '1fr', '1fr', '3fr 2fr'],
    gridTemplateAreas: [
      '"first" "second" "third"',
      '"first" "second" "third"',
      '"first" "second" "third"',
      '"first third" "second  third"',
    ],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;
  width: 100%;
  grid-template-areas:
    'first third'
    'second  third';

  > div:first-child {
    grid-area: first;
  }

  > div:nth-child(2) {
    grid-area: second;
  }

  > div:last-child {
    grid-area: third;
  }

  ${grid}
`

export const Card = styled.div.attrs({
  px: [24, 24, 32, 32, 40],
  py: [24, 24, 28],
})`
  border-radius: 20px;
  background-color: ${themeGet('colors.spaceCadet')};

  ${padding}
`

export const ButtonHolder = styled.div.attrs({
  display: ['none', 'none', 'none', 'block'],
})`
  ${layout}
`
